import {Pipe, PipeTransform} from '@angular/core';
import {TranslateParser, TranslateService} from '@ngx-translate/core';

import isEmpty from 'lodash-es/isEmpty';
import omit from 'lodash-es/omit';

import {DATE_FORMAT} from '../../app.constants';
import {LocalizationService} from '../localization/localization.service';
import {Variable} from '../workflow/workflow-v2.interface';

const moment = require('moment');

export const isValidDate = (value: string) => moment(value, DATE_FORMAT, true).isValid();
export const hasNoInterpolationParam = (value: string) => !new RegExp(/\{\{.*\}\}/).test(value);
export const isBankingDetails = (variableName, value) => {
  return variableName === 'groupName' && typeof value === 'string' && value.includes(':') && value.includes('_');
};
export const formatBankingDetails = (value) => {
  const valueArray = value.split('_');
  return valueArray.slice(0, valueArray.length - 1).join('_');
};

@Pipe({name: 'translateAndFormatVariables'})
export class TranslateAndFormatVariablesPipe implements PipeTransform {
  private dateFormat: string;

  constructor(private translateParser: TranslateParser,
              private localization: LocalizationService,
              private translate: TranslateService) {
    this.dateFormat = this.localization.dateFormat;
  }

  public transform(value: string, variables: Variable[], trigger?: number): string {
    if (isEmpty(variables) || hasNoInterpolationParam(value)) {
      return value;
    }
    if (trigger !== null) {
      this.dateFormat = this.localization.dateFormat;
    }
    const params = variables.reduce((previous, variable) => {
      return {
        ...previous,
        [variable.name]: this.formatValue(variable)
      };
    }, {});
    return this.translateParser.interpolate(value, params);
  }

  private formatValue = (variable: Variable) => {
    const value = variable.value;
    if (value === null) {
      return '';
    }
    if (variable.type === 'serializable') {
      return Object.keys(omit(value, 'values')).reduce((previous, key) => {
        return {
          ...previous,
          [key]: this.formatAndTranslate(key, value[key])
        };
      }, {});
    }
    return this.formatAndTranslate(variable.name, value);
  }

  private formatAndTranslate = (key: string, value) => isValidDate(value)
    ? this.formatDate(value)
    : isBankingDetails(key, value) ? this.translate.instant(formatBankingDetails(value)) : this.translate.instant(value)

  private formatDate = value => {
    if (value === '1970-01-01') {
      return this.translate.instant('EMPLOYEE_MANAGE.beginning_of_contract');
    }
    if (value === '3000-01-01') {
      return this.translate.instant('EMPLOYEE_MANAGE.end_of_contract');
    }
    return moment(value, DATE_FORMAT).format(this.dateFormat);
  }
}
